<div class='center'>
	<span class='h1 mb3 block'>Ingresando...</span>
	<mat-spinner class='mx-auto' diameter="50"></mat-spinner>
</div>
